import React from 'react';

export const StepContext = React.createContext({});
